import React from "react";

const ScriptureHtmlView = ({ content }: { content: string }) => (
  <div
    className="scripture"
    dangerouslySetInnerHTML={{
      __html: content
    }}
  />
);

export default ScriptureHtmlView;
